export const GET_SCRAP_JASAN_INFOS = 'GET_SCRAP_JASAN_INFOS'
export const UNLOAD_SCRAP = 'UNLOAD_SCRAP'


// WEBPACK FOOTER //
// ./src/constants/scrap.js